export default "__VITE_ASSET__79399bc8__"